import { render, staticRenderFns } from "./auto_view_tab.vue?vue&type=template&id=09845dfd&scoped=true"
import script from "./auto_view_tab.vue?vue&type=script&lang=js"
export * from "./auto_view_tab.vue?vue&type=script&lang=js"
import style0 from "./auto_view_tab.vue?vue&type=style&index=0&id=09845dfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09845dfd",
  null
  
)

export default component.exports